import { CSSProperties, FC } from "react";
import {
    EventName,
    IncidentEvent,
    MatchEventPlottingData,
    MatchPhone,
} from "refsix-js-models";
import { eventDisplayMinute } from "../../../utils/stoppingClockDisplay";

interface ReplayCardmapProps {
    cardMapData: MatchEventPlottingData;
    // Only reveal cards whose position has been reached during playback.
    currentTimestamp: number;
    match: MatchPhone;
}

const CARD_WIDTH = 15;
const CARD_HEIGHT = 20;

/**
 * Disciplinary cards plotted on the pitch, revealed as the video reaches each
 * incident. Ported from the legacy LiveCardmapDirective.
 */
const ReplayCardmap: FC<ReplayCardmapProps> = ({
    cardMapData,
    currentTimestamp,
    match,
}) => {
    const width = cardMapData.width;
    const height = Math.ceil(cardMapData.height);
    const divHeight = height - CARD_HEIGHT;

    const cards = cardMapData.data
        .filter(
            (eventContainer) =>
                eventContainer.event.eventName === EventName.incident &&
                (eventContainer.point.timestamp || 0) <= currentTimestamp
        )
        .map((eventContainer, idx) => {
            const event = eventContainer.event as IncidentEvent;
            const point = eventContainer.point;
            const initialTop = (point.y || 0) - CARD_HEIGHT / 2;
            const top =
                initialTop > divHeight
                    ? divHeight
                    : initialTop < 0
                    ? 0
                    : initialTop;
            const left = (point.x || 0) - CARD_WIDTH / 2;
            const style: CSSProperties = {
                height: CARD_HEIGHT,
                top,
                left,
                position: "absolute",
            };
            return (
                <div key={idx} style={style}>
                    <div className={"card " + event.card}>
                        <span className="player-no">{event.player.number}</span>
                    </div>
                    <span className="minute">
                        {eventDisplayMinute(event, match)}
                    </span>
                </div>
            );
        });

    return (
        <div
            className="replay-layer replay-cardmap-layer card-map"
            style={{ width, height }}
        >
            {cards}
        </div>
    );
};

export default ReplayCardmap;
